module.exports = __webpack_public_path__ + "static/media/FoundersGroteskWeb-Regular.bfa8353b.eot";